import * as React from "react";
import * as S from "@styled";
import { getDraftEditLink } from "../model/AppLinks";
import { Draft } from "../model/Process";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { DraftListTable } from "shared/components/Table";
import { DraftType } from "shared/model/Table";
import Time from "shared/Time";

const columnHelper = createColumnHelper<DraftType>()

export const DraftList: React.FC<DraftListProps> = (props) => {

    const confirmDiscardDraft = (draftId: number) => {
        if (confirm(FRENDS.Localizations.Confirm_Delete)) {
            props.onDiscardDraft(draftId);
        }
    }

    const columns: Array<ColumnDef<DraftType, unknown>> = [
        columnHelper.accessor("id", {
            cell: (cell) => cell.getValue(),
            header: () => null
        }),
        columnHelper.accessor("processId", {
            cell: (cell) => cell.getValue(),
            header: () => null
        }),
        columnHelper.accessor("name", {
            header: () => FRENDS.Localizations.Name,
            cell: (cell) => (
                <S.A variant={S.LinkTextColor.black}
                    className="process-name-selector"
                    title={FRENDS.Localizations.Edit}
                    href={getDraftEditLink(cell.row.original.id)}
                >
                    <span>{cell.getValue()}</span>
                    {!cell.row.original.processId ? <i title={FRENDS.Localizations.NotYetSaved} className="ci-edit"></i> : null}
                </S.A>
            )
        }),
        columnHelper.accessor("modified", {
            header: () => FRENDS.Localizations.Modified,
            cell: (cell) => Time.toDetailedLocalTime(cell.getValue())
        }),
        columnHelper.accessor("modifier", {
            header: () => FRENDS.Localizations.Modifier,
        }),
        columnHelper.accessor("deleteAction", {
            header: () => null,
            cell: (cell) => (
                <div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
                    <S.Button title={FRENDS.Localizations.Discard}
                        onClick={() => confirmDiscardDraft(cell.row.original.id)}
                        variant={S.ButtonType.text}
                    >
                        {FRENDS.Localizations.Discard}
                    </S.Button>
                </div>
            )
        })
    ];

    const data: DraftType[] = props.drafts.map((draft) => ({
        id: draft.id,
        processId: draft.processId,
        name: draft.name,
        modified: draft.modified,
        modifier: draft.modifier
    }));

    return (
        <>
            <h2 style={{ margin: "25px 0" }}>{FRENDS.Localizations.Drafts}</h2>
            <DraftListTable
                data={data}
                columns={columns}
            />
        </>
    );
};

interface DraftListProps {
    drafts: Draft[];
    onDiscardDraft: (id: number) => void;
}